import request from "./request";

const api = {
  getList: "notice/getList",
  getUnreadCount: "notice/getUnreadCount",
  read: "notice/read",
};

export default {
  /** 站内消息列表（page/size 分页） */
  getList(parameter) {
    return request({
      url: api.getList,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 站内消息未读数 */
  getUnreadCount(parameter) {
    return request({
      url: api.getUnreadCount,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 标记站内消息已读 */
  read(parameter) {
    return request({
      url: api.read,
      method: "POST",
      data: parameter || {},
    });
  },
};
